import { useEffect, useRef } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
        (async () => {
            try {
                const { data } = await axios.post(
                    `${API}/auth/session`,
                    { session_id: sessionId },
                    { withCredentials: true }
                );
                navigate("/admin", { state: { user: data }, replace: true });
            } catch (err) {
                const detail = err.response?.data?.detail;
                toast.error(typeof detail === "string" ? detail : "Google sign-in failed");
                navigate("/login", { replace: true });
            }
        })();
    }, [location, navigate]);

    return (
        <div data-testid="auth-callback" className="min-h-screen bg-[#0F0C08] flex flex-col items-center justify-center gap-4">
            <Loader2 size={26} className="animate-spin text-[#C58B49]" />
            <p className="font-mono2 text-[11px] tracking-[0.3em] uppercase text-[#8C8075]">Signing you in…</p>
        </div>
    );
}
